<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import map from '@/assets/images/contact/map.png'

const store = useStore()

const companyInfo = computed(() => store.state.companyInfo)

const currentLang = computed(() => store.getters.currentLanguage)

const address = computed(() => {
	return companyInfo.value?.[`company_address_${currentLang.value}`]
})

const contactInfo = computed(() => {
	return [
		{
			label: "contact.contact.phone",
			value: companyInfo.value?.contact_phone,
			icon: 'telephone-fill'
		},
		{
			label: "contact.contact.fax",
			value: companyInfo.value?.facsimile,
			icon: 'fax-fill'
		},
		{
			label: "contact.contact.email",
			value: companyInfo.value?.email,
			icon: 'email-fill'
		}
	]
})

const businessContact = computed(() => {
	return {
		domestic: companyInfo.value?.business_contact_domestic,
		international: companyInfo.value?.business_contact_international,
		Daxie: companyInfo.value?.technical_contact_domestic,
		Beilun: companyInfo.value?.technical_contact_international
	}
})
</script>

<template>
	<div class="contact">
		<el-row type="flex" justify="space-between" :gutter="20" class="contact__row">
			<el-col
				v-for="(item, index) in contactInfo"
				:key="index"
				:xs="24"
				:sm="24"
				:md="8"
				:lg="8"
				:xl="8"
				class="col-card"
			>
				<div class="contact__card">
					<div class="left">
						<SvgIcon
							:name="item.icon"
							class-name="contact__card__icon"
						/>
					</div>
					
					<div class="right">
						<div class="label">{{ $t(item.label) }}</div>
						<div class="value">{{ item.value }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
		
		<el-row type="flex" justify="space-between" class="contact__row">
			<el-col>
				<div class="contact__card">
					<div class="left">
						<SvgIcon
							name="local-fill"
							class-name="contact__card__icon"
						/>
					</div>
					
					<div class="right">
						<div class="label">{{ $t('contact.contact.address') }}</div>
						<div class="value">{{ address }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
		
		<div class="contact__business">
			<div class="contact__business__row">
				<div class="title">
					<div>
						<SvgIcon
							name="business-fill"
							class-name="title__icon"
						/>
					</div>
					
					<div class="title__text">
						{{ $t('contact.business.title') }}
					</div>
				</div>
				
				<div class="info">
					<div class="info__content">
						{{ $t('contact.business.domestic') }}: {{ businessContact.domestic }}
					</div>
					
					<div class="info__content">
						{{ $t('contact.business.international') }}: {{ businessContact.international }}
					</div>
				</div>
			</div>
			
			<div class="contact__business__row">
				<div class="title">
					<div>
						<SvgIcon
							name="technology-fill"
							class-name="title__icon"
						/>
					</div>
					
					<div class="title__text">
						{{ $t('contact.technology.title') }}
					</div>
				</div>
				
				<div class="info">
					<div class="info__content">
						{{ $t('contact.technology.Daxie') }}: {{ businessContact.Daxie }}
					</div>
					
					<div class="info__content">
						{{ $t('contact.technology.Beilun') }}: {{ businessContact.Beilun }}
					</div>
				</div>
			</div>
		</div>
		
		<div class="contact__card" style="margin-bottom: 0;">
			<el-image :src="map" style="width: 100%; height: 100%;" />
		</div>
		
	</div>
</template>

<style scoped lang="less">
.contact {
	
	&__row {
		margin-bottom: 24px;
	}
	
	&__business {
		padding: 32px 24px;
		background-color: #fff;
		margin-bottom: 24px;
		
		&__row {
			margin-bottom: 32px;
			
			&:last-child {
				margin-bottom: 0;
			}
			
			.title {
				display: flex;
				align-items: center;
				padding-bottom: 12px;
				border-bottom: 1px solid #E4E7ED;
				
				&__icon {
					width: 24px;
					height: 24px;
				}
				
				&__text {
					margin-left: 12px;
					font-size: 18px;
					color: #909399;
				}
			}
			
			.info {
				margin-top: 16px;
				display: flex;
				
				&__content {
					font-size: 24px;
					color: #303133;
					width: 50%;
				}
			}
			
		}
	}
	
	&__card {
		padding: 24px;
		background-color: #fff;
		display: flex;
		align-items: center;
		
		&__icon {
			width: 36px;
			height: 36px;
		}
		
		.left {
			margin-right: 16px;
		}
		
		.right {
			
			.label {
				font-size: 18px;
				color: #909399;
			}
			
			.value {
				margin-top: 8px;
				font-size: 24px;
				color: #303133;
			}
		}
	}
}

@media only screen and (max-width: 1300px) {
	.contact {
		
		&__business {

		}
		
		&__card {
			
			.right {
				
				.value {
					font-size: 16px;
				}
			}
		}
	}
}

@media only screen and (max-width: 990px) {
	.contact {
		
		.col-card {
			margin-bottom: 20px;
			
			&:last-child {
				margin-bottom: 0;
			}
		}
		
		&__card {
			
			.right {
				
				.label {
					font-size: 16px;
				}
				
				.value {
					font-size: 18px;
				}
				
			}
		}
		
		&__business {
			padding: 20px 24px;
			margin-bottom: 20px;
			
			&__row {
				margin-bottom: 20px;
				
				&:last-child {
					margin-bottom: 0;
				}
				
				.title {
					
					&__icon {
						width: 20px;
						height: 20px;
					}
					
					&__text {
						font-size: 16px;
					}
				}
				
				.info {
					margin-top: 16px;
					display: flex;
					flex-direction: column;
					
					&__content {
						font-size: 18px;
						width: 100%;
						margin-bottom: 8px;
						
						&:last-child {
							margin-bottom: 0;
						}
						
					}
				}
				
			}
		}
		
	}
}
</style>